import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import Button from '@/components/UI/Button';
import ReactSelect from '@/components/UI/Form/ReactSelect';
import Modal from '@/components/UI/Modal';
import { patchProject } from '../../../../../../../api/Sherpa/Project';
import { useProject } from '../../../../../../../hooks/ReactQueryHooks/useProjectQuery';
import { useWorkspaces } from '../../../../../../../hooks/ReactQueryHooks/useWorkspaceQuery';
import { notifyUser } from '../../../../../../../store/Toast';
import { sanitizeResponseError } from '../../../../../../../utils';

interface ChangeProjectWorkspaceProps {
  handleModal: () => void;
}

const ChangeProjectWorkspace = ({ handleModal }: ChangeProjectWorkspaceProps) => {
  const { projectId } = useParams<string>();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedWorkspace, setSelectedWorkspace] = useState<IGetWorkspacesServiceResData | null>(null);

  const fetchProject = useProject({ projectId: Number(projectId) });
  const projectWorkspace = fetchProject?.data?.data?.workspace;

  const fetchWorkspaces = useWorkspaces({});
  const workspaces = fetchWorkspaces?.data;

  const updateProjectWorkspace = useMutation(
    () =>
      patchProject({
        projectId: Number(projectId),
        data: { workspaceId: selectedWorkspace?.id },
      }),
    {
      onSuccess: () => {
        navigate('/app/sherpa/projects', { replace: true });
        handleModal();
        dispatch(
          notifyUser({
            showToast: true,
            toastMessage: 'Project workspace changed successfully.',
            toastType: 'success',
          })
        );
      },
      onError: (error: any) => {
        const resError = sanitizeResponseError(error);
        dispatch(
          notifyUser({
            showToast: true,
            toastMessage: resError,
            toastType: 'failed',
          })
        );
      },
    }
  );

  return (
    <Modal>
      <div>
        <h2 className='mt-0'>Project Workspace</h2>
        <ReactSelect
          id='projectWorkspace'
          name='projectWorkspace'
          options={workspaces}
          defaultValue={{
            id: projectWorkspace?.id,
            name: projectWorkspace?.name,
          }}
          getOptionLabel={(option) => (option as IGetWorkspacesServiceResData).name}
          getOptionValue={(option) => (option as IGetWorkspacesServiceResData)?.id?.toString()}
          onChange={(option) => setSelectedWorkspace(option as IGetWorkspacesServiceResData)}
        />
        <div className='flex gap-4 justify-end mt-5'>
          <Button label='Cancel' btnStyle='btn-neutral' onClick={handleModal} />
          <Button label='Change' btnStyle='btn-primary' onClick={updateProjectWorkspace.mutate} />
        </div>
      </div>
    </Modal>
  );
};

export default ChangeProjectWorkspace;
